export default {
    tips: "로그인 상태에서만 충전이 가능하오니 번거로우시더라도 계정 접속 여부를 확인해 보신 후 진행해 보시기 바랍니다. 참고로 환불을 원하실 경우 7일내 청약철회를 불가한 상품만 진행이 가능하며, 자체환불 시 시스템 정지 처리가 진행됩니다.",
    userAgreement: "이용약관",
    privacyAgreement: "개인정보 보호정책",
    company: "Amazing Cat Interactive Entertainment Technology",
    email: "메일：amazingcatkr@gmail.com",
    methods: {
        logoutMsg: "로그아웃하시겠습니까",
        tips: "알림",
        confirm: "확인",
        cancellation: "취소"
    }
}
